var map = {
	"./Abroad-third-party/store/library.js": "f0bf",
	"./access-restriction/store/library.js": "2894",
	"./accessor/store/library.js": "3c08",
	"./account/store/account-workspace-organization.js": "30e6",
	"./account/store/management.js": "06e2",
	"./account/store/user.js": "ea51",
	"./agreement-type/store/library.js": "d670",
	"./announcement/store/announcement.js": "3990",
	"./application/store/application.js": "2069",
	"./approval/store/approval.js": "3bae",
	"./archive-environments/store/library.js": "ece7",
	"./archive-environments/store/organization.js": "dfcd",
	"./asset-group-category-asset-group-survey/store/organization.js": "e258",
	"./asset-group-category-asset-group/store/boxes.js": "5567",
	"./asset-group-category-asset-group/store/organization.js": "8d1c",
	"./asset-group-inventory/store/index.js": "77b2",
	"./asset-group/store/library.js": "9e24",
	"./asset-group/store/organization.js": "d6bb",
	"./collect-method/store/library.js": "8dc8",
	"./config/store/index.js": "2dc4",
	"./data-breach/store/organization.js": "f164",
	"./data-datasubject/store/organization.js": "6467",
	"./data/store/library.js": "c3b8",
	"./data/store/organization.js": "079c",
	"./datasource/store/library.js": "096f",
	"./datasource/store/organization.js": "8b87",
	"./datasubject-right/store/index.js": "dcb1",
	"./datasubject/store/library.js": "cd76",
	"./datasubject/store/organization.js": "4922",
	"./department-process/store/organization.js": "8abb",
	"./department/store/library.js": "9dd5",
	"./department/store/organization.js": "85de",
	"./domestic-third-party/store/library.js": "2887",
	"./entity/store/organization.js": "7986",
	"./file-approval-survey/store/organization.js": "e68a",
	"./file-manager/store/index.js": "c800",
	"./inventory/component/access-and-restriction/store/index.js": "e117",
	"./inventory/component/bulk-update/store/index.js": "3864",
	"./inventory/component/datasubject-right/store/datasubject.js": "2aa8",
	"./inventory/component/direct-collect-method/store/index.js": "83b8",
	"./inventory/component/disposal-method/store/index.js": "b478",
	"./inventory/component/electronic-archive/store/index.js": "725d",
	"./inventory/component/electronic-storage/store/index.js": "6f81",
	"./inventory/component/filter/store/filter.js": "bc2a",
	"./inventory/component/other-collect-method/store/index.js": "be1b",
	"./inventory/component/physical-archive/store/index.js": "1c8a",
	"./inventory/component/physical-storage/store/index.js": "608f",
	"./inventory/component/processing/store/datasubject.js": "6931",
	"./inventory/component/transfering/store/datasubject.js": "0c39",
	"./inventory/store/inventory-import.js": "e0dd",
	"./inventory/store/inventory.js": "b861",
	"./layout/store/index.js": "248b",
	"./legal-document/store/filter.js": "d200",
	"./legal-document/store/library.js": "e41a",
	"./legal-document/store/organization.js": "8a4a",
	"./localization/store/localization.js": "b8e6",
	"./log/store/log.js": "791d",
	"./mail-log/store/mail-log.js": "84a1",
	"./measure/store/index.js": "c63b",
	"./module-settings/store/module-settings.js": "418f",
	"./notification-type/store/library.js": "ea29",
	"./notification/store/index.js": "4034",
	"./organization/store/management.js": "40f1",
	"./organization/store/organization.js": "5e4b",
	"./organization/store/workspace.js": "f3a6",
	"./permission/store/index.js": "fcb4",
	"./policy/store/library.js": "6584",
	"./policy/store/organization.js": "7b39",
	"./possible-effect/store/library.js": "beba",
	"./process-data/store/organization.js": "b1ff",
	"./process-datasource/store/organization.js": "0962",
	"./process/store/library.js": "de59",
	"./process/store/organization.js": "a6ae",
	"./processing-adjective/store/library.js": "154c",
	"./processing-transferring/store/library.js": "8912",
	"./products/store/index.js": "709a",
	"./question-set-and-survey/store/organization.js": "65f3",
	"./question/store/library.js": "8985",
	"./question/store/organization.js": "8bfe",
	"./quick-hierarchy/store/asset-group-category-asset-group.js": "21cc",
	"./quick-hierarchy/store/datasource-data.js": "ce23",
	"./quick-hierarchy/store/department-process-datasource-datasubject.js": "50f5",
	"./quick-hierarchy/store/department-process.js": "24ac",
	"./quick-hierarchy/store/process-datasource-datasubject-processing-legal.js": "c178",
	"./quick-hierarchy/store/process-datasource-datasubject-transfering-legal.js": "0f96",
	"./quick-hierarchy/store/process-datasource-storage-period.js": "c0f0",
	"./quick-hierarchy/store/process-datasource.js": "19f8",
	"./quick-hierarchy/store/product-asset-group-category.js": "4fc4",
	"./quick-hierarchy/store/quick-hierarchy.js": "8606",
	"./quick-hierarchy/store/risk-definition-applied-control.js": "6d0a",
	"./quick-hierarchy/store/sector-department.js": "905b",
	"./receiver-group/store/library.js": "ce1b",
	"./receiver-group/store/organization.js": "89a1",
	"./report-template/store/library.js": "4796",
	"./report-template/store/organization.js": "0741",
	"./request-queue/store/index.js": "2325",
	"./risk/store/library.js": "650a",
	"./risk/store/organization.js": "a4a8",
	"./roadmap/store/bgys.js": "7608",
	"./roadmap/store/ddo.js": "d666",
	"./roadmap/store/gdpr.js": "ac3e",
	"./roadmap/store/kvkk.js": "76e8",
	"./roadmap/store/organization.js": "dedf",
	"./roadmap/store/platform.js": "d33c",
	"./role-access/store/role-access.js": "ecb6",
	"./role/store/role.js": "e7ea",
	"./safe-country-map/store/library.js": "6a49",
	"./sector/store/sector.js": "3c22",
	"./source-and-type/store/library.js": "ec40",
	"./storage-environments/electronic-storage/store/organization.js": "ae52",
	"./storage-environments/physical-storage/store/organization.js": "08f1",
	"./storage-environments/store/library.js": "6ed9",
	"./survey/store/organization.js": "21ac",
	"./synchronization/store/synchronization.js": "a8e0",
	"./system-flow/store/index.js": "d048",
	"./task/store/library.js": "5e6a",
	"./task/store/periodic-task.js": "5b9f",
	"./task/store/task-settings.js": "7d0a",
	"./task/store/task.js": "d80f",
	"./thirdparty/store/organization.js": "11e4",
	"./transfer-library/store/library.js": "38a4",
	"./transfering/store/library.js": "cbad",
	"./workspace/store/management.js": "e9f9",
	"./workspace/store/switch-workspace.js": "6359",
	"./workspace/store/workspace-role.js": "6711",
	"./workspace/store/workspace.js": "dcd3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1457";